/**
 * 型番検索 trong thân trang `/pages/search-toner` — port
 * `shop.toner_search_ajax.php` (nhánh `tonerPage=1`) + template kết quả
 * `browse/includes/toner_search.tpl.php`.
 *
 * Markup 2 ô search (`.toner_SearchBox.js-searchBox`, `data-search-id` 1/2) nằm
 * trong `Page.body` migrate từ Joomla. Script gốc của Joomla nhúng cùng body đã bị
 * Shopify strip khi import (Shopify xoá sạch `<script>`/`<style>` khỏi body page),
 * nên toàn bộ handler phải sống ở theme — file này.
 *
 * API: GET /apps/ink/api/v1/search/printer-suggestions?q=&category_type=TTP&maker=&checked=
 *   = bản port 1:1 `ps_product_category::getPrinterCategoryNew()`, đúng method mà
 *   `shop.toner_search_ajax.php:77` gọi. Chuẩn hoá kana (mb_convert_kana KaC/ac),
 *   tách tối đa 5 term, merge 適合トナー đều do server làm — client gửi keyword thô.
 *
 * Helper `esc` / `handleize` / `collectionUrl` / `whenApiReady` là bản copy có chủ ý
 * từ `assets/printer-model-search.js`: cùng API nhưng khác tham số hành vi (ô này
 * KHÔNG có ngưỡng 2 ký tự, debounce 300ms thay vì 500ms, có khối 絞り込み + 件数),
 * và theme để mỗi asset là 1 IIFE tự chứa.
 *
 * Link kết quả: site cũ trỏ `/index.php/{category_name}.html`; ở đây là
 * `/collections/{handle}` — collection chưa tồn tại thì ra 404 native (quyết định
 * giống search overlay + chip 適合プリンター).
 *
 * Class sinh bằng string ở đây được khai trong
 * `assets/shopify-fixed-page-content.modules.css` (scope `data-page-handle`).
 */
(function () {
  'use strict';

  var DEBOUNCE_MS = 300;
  var MAX_REQUESTS_PER_MINUTE = 40;
  var RATE_WINDOW_MS = 60000;
  var CATEGORY_TYPE = 'TTP';

  // Keyword "rỗng về mặt nội dung": Joomla chạy query khi
  // `preg_match('/[^\p{Z}\p{C}]+/u', $word)` (shop.toner_search_ajax.php:65).
  // KHÔNG dùng String.trim() — trim chỉ bỏ một tập con của \p{Z}/\p{C}.
  var BLANK_ONLY = /^[\p{Z}\p{C}]*$/u;

  // Radio メーカー của khối kết quả — `makerListJPSearchForToner`
  // (ps_product_category.cfg.php:233). Thứ tự khai báo = thứ tự render.
  var MAKER_OPTIONS = [
    { value: '0', label: 'すべて' },
    { value: '2', label: 'Canon' },
    { value: '5', label: 'brother' },
    { value: '7', label: 'RICOH' },
    { value: '13', label: 'OKI' },
    { value: '11', label: 'Fuji Xerox' },
    { value: '1', label: 'EPSON' },
    { value: '10', label: 'NEC' },
    { value: '99', label: 'その他' },
  ];

  var NO_RESULT_TEXT =
    '該当する型番がありませんでした。恐れ入りますが、キーワードを変更してもういちど検索してください。';

  // Trần request dùng chung cho cả 2 ô (site cũ đếm ở scope module của script nhúng
  // trong body, tức cũng dùng chung toàn trang).
  var requestCount = 0;
  var rateWindowStart = Date.now();

  function withinRateLimit() {
    var now = Date.now();
    if (now - rateWindowStart > RATE_WINDOW_MS) {
      rateWindowStart = now;
      requestCount = 0;
    }
    if (requestCount >= MAX_REQUESTS_PER_MINUTE) {
      console.warn('1分間に40回のリクエストの上限に達しました。');
      return false;
    }
    requestCount += 1;
    return true;
  }

  // `api-client.js` load cuối body và set `window.inkApi` trong DOMContentLoaded của
  // chính nó; script này được nhúng từ page content nên chạy TRƯỚC → luôn phải chờ
  // event `ink:api:ready`, không phải guard phòng hờ.
  function whenApiReady(timeoutMs) {
    if (window.inkApi) return Promise.resolve(window.inkApi);
    return new Promise(function (resolve) {
      var done = function () {
        resolve(window.inkApi || null);
      };
      document.addEventListener('ink:api:ready', done, { once: true });
      setTimeout(done, timeoutMs);
    });
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Handleize giống Liquid filter: lowercase, ký tự không phải chữ/số → '-', trim '-'.
  function handleize(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');
  }

  function collectionUrl(item) {
    var handle = item.shopify_collection_handle || handleize(item.category_name);
    // Handle rỗng (tên toàn ký tự đặc biệt) → giữ tên raw để chắc chắn 404, tránh
    // `/collections/` trần (Shopify render danh sách toàn bộ collection).
    return '/collections/' + (handle || encodeURIComponent(item.category_name || 'not-found'));
  }

  /**
   * Gom item theo maker × 型番kind rồi sắp key — port `$jsonArr` + `ksort`
   * (shop.toner_search_ajax.php:80-96, :113).
   *
   * `maker_name` lấy thẳng từ API (backend resolve qua `makerListJP` với fallback
   * chuỗi rỗng, khớp `$makerlist[$id]` undefined của Joomla) — KHÔNG dựng lại bảng
   * maker trong JS để tránh lệch khi backend đổi.
   *
   * Thứ tự item trong 1 nhóm = thứ tự phẳng của API: `groupByMaker()` phía server
   * không sort, giữ nguyên `$mainRows->concat($compatRows)` = `array_merge` của
   * Joomla; gom lại theo (maker, kind) mịn hơn nên thứ tự trong bucket không đổi.
   */
  function buildGroups(apiGroups) {
    var buckets = Object.create(null);
    var order = [];

    apiGroups.forEach(function (group) {
      var makerName = group.maker_name || '';
      (group.items || []).forEach(function (item) {
        // CATEGORY_KIND_TONER = 2; mọi kind còn lại của TTP là プリンター (kind 4).
        var key = makerName + ' / ' + (Number(item.category_kind) === 2 ? 'トナー' : 'プリンター');
        if (!buckets[key]) {
          buckets[key] = [];
          order.push(key);
        }
        buckets[key].push(item);
      });
    });

    // `ksort()` với SORT_REGULAR rơi về strcmp (byte-wise UTF-8); `sort()` mặc định
    // của JS so UTF-16 code unit. Mọi tên maker đều nằm trong BMP nên 2 thứ tự trùng
    // nhau. CẤM đổi sang localeCompare/Intl.Collator — collation `ja` xếp
    // 日立 trước 富士ゼロックス, lệch site cũ.
    order.sort();

    return order.map(function (key) {
      return { key: key, items: buckets[key] };
    });
  }

  function groupsHtml(groups) {
    if (!groups.length) {
      return '<p class="ModelNumberResultBox__NoResult">' + esc(NO_RESULT_TEXT) + '</p>';
    }
    return groups
      .map(function (group) {
        var items = group.items
          .map(function (item) {
            return (
              '<li><a href="' +
              esc(collectionUrl(item)) +
              '">' +
              esc(item.display_name) +
              '</a></li>'
            );
          })
          .join('');
        return '<div class="resultTit">' + esc(group.key) + '型番</div><ul>' + items + '</ul>';
      })
      .join('');
  }

  /**
   * Khối 絞り込み検索 — port toner_search.tpl.php:7-31.
   *
   * `name`/`id` gắn hậu tố `suffix` (= `data-search-id`): 2 ô search cùng trang, để
   * nguyên tên gốc thì radio 2 ô chung một group và `<label for>` của ô dưới sẽ
   * toggle checkbox của ô trên.
   */
  function refineHtml(suffix, checkedKinds, makerValue) {
    var kindBoxes = [
      { id: 'tonner', value: '2', label: 'トナー型番' },
      { id: 'printer', value: '4', label: 'トナープリンター型番' },
    ]
      .map(function (kind) {
        var id = kind.id + '-' + suffix;
        return (
          '<span class="Refine__Check"><input id="' +
          esc(id) +
          '" name="typeSiteSearch-' +
          esc(suffix) +
          '" value="' +
          kind.value +
          '" type="checkbox"' +
          (checkedKinds.indexOf(kind.value) !== -1 ? ' checked' : '') +
          '><label for="' +
          esc(id) +
          '">' +
          esc(kind.label) +
          '</label></span>'
        );
      })
      .join('');

    var makerRadios = MAKER_OPTIONS.map(function (maker) {
      var id = 'site_search_maker_' + maker.value + '-' + suffix;
      return (
        '<span class="Refine__Check"><input type="radio" id="' +
        esc(id) +
        '" name="siteSearchMaker2-' +
        esc(suffix) +
        '" value="' +
        esc(maker.value) +
        '"' +
        (maker.value === makerValue ? ' checked' : '') +
        '><label for="' +
        esc(id) +
        '">' +
        esc(maker.label) +
        '</label></span>'
      );
    }).join('');

    return (
      '<div class="ModelNumberResultBox__Refine">' +
      '<div class="Refine__MainTitle">絞り込み検索</div>' +
      '<div class="Refine__Box Refine__Box--Type"><div class="Refine__SubTitle">種類：</div>' +
      kindBoxes +
      '</div>' +
      '<div class="Refine__Box"><div class="Refine__SubTitle">メーカー：</div>' +
      makerRadios +
      '</div>' +
      '</div>'
    );
  }

  function panelHtml(suffix, total, checkedKinds, makerValue, groups) {
    return (
      '<div class="searchBox__printerResultBox">' +
      '<div class="searchBox__printerResultBoxInner">' +
      '<div class="ModelNumberResultBox__HitNum">検索結果：' +
      esc(String(total)) +
      '件</div>' +
      refineHtml(suffix, checkedKinds, makerValue) +
      groupsHtml(groups) +
      '<a class="searchBox__closeBtn" role="button" tabindex="0">検索結果を閉じる</a>' +
      '<a class="searchBox__closeIconBtn" role="button" tabindex="0" aria-label="検索結果を閉じる"></a>' +
      '</div></div>'
    );
  }

  function bind(box) {
    if (box.dataset.inkTonerSearchBound === '1') return;
    box.dataset.inkTonerSearchBound = '1';

    var suffix = box.dataset.searchId || '1';
    var input = box.querySelector('.js-searchInput');
    var makerSelect = box.querySelector('.js-searchMaker');
    var result = box.querySelector('.js-resultBox');
    if (!input || !result) return;

    var timer = null;
    var seq = 0;
    var cache = Object.create(null);

    function checkedKinds() {
      return Array.prototype.map.call(
        box.querySelectorAll('input[name^="typeSiteSearch"]:checked'),
        function (el) {
          return el.value;
        },
      );
    }

    function clearPanel() {
      result.innerHTML = '';
      box.classList.remove('is-open');
    }

    function render(total, kinds, makerValue, groups) {
      result.innerHTML = panelHtml(suffix, total, kinds, makerValue, groups);
      box.classList.add('is-open');
    }

    function search() {
      var word = input.value;
      var kinds = checkedKinds();
      // `categorycheck` gửi nguyên value của select, kể cả 99 (その他). API không có
      // nhánh cho 99 nên không lọc maker — giữ đúng quirk `getPrinterCategoryNew`
      // (:2042-2073, `case 16` cũng không phủ TTP nên không thay được bằng 16).
      var makerValue = makerSelect ? makerSelect.value : '0';

      if (word === '') {
        clearPanel();
        return;
      }

      // Keyword toàn khoảng trắng (kể cả U+3000): Joomla bỏ query nhưng VẪN vẽ panel
      // 0件 + 絞り込み. API thì trả 422 QUERY_TOO_SHORT, nên chặn ở client.
      if (BLANK_ONLY.test(word)) {
        seq += 1;
        render(0, kinds, makerValue, []);
        return;
      }

      var params = { q: word, category_type: CATEGORY_TYPE, maker: makerValue };
      if (kinds.length) params.checked = kinds.join(',');

      var cacheKey = makerValue + '|' + kinds.join(',') + '|' + word;
      var ticket = (seq += 1);

      if (cache[cacheKey]) {
        var hit = cache[cacheKey];
        render(hit.total, kinds, makerValue, hit.groups);
        return;
      }

      if (!withinRateLimit()) return;

      whenApiReady(3000)
        .then(function (api) {
          if (!api) return null;
          return api.get('/search/printer-suggestions', params);
        })
        .then(function (res) {
          // Response về sau khi user đã gõ tiếp → bỏ, tránh đè kết quả mới hơn.
          if (ticket !== seq || res === null) return;

          var data = (res && res.data) || {};
          var groups = buildGroups(Array.isArray(data.groups) ? data.groups : []);
          var total = Number(data.total) || 0;
          cache[cacheKey] = { total: total, groups: groups };
          render(total, kinds, makerValue, groups);
        })
        .catch(function (e) {
          console.warn('printer-suggestions load fail', e);
          // Fail-open: ẩn panel, list maker phía dưới ô search vẫn dùng được.
          if (ticket === seq) clearPanel();
        });
    }

    function debouncedSearch() {
      clearTimeout(timer);
      timer = setTimeout(search, DEBOUNCE_MS);
    }

    input.addEventListener('keyup', debouncedSearch);
    input.addEventListener('click', debouncedSearch);

    // Delegation: khối 絞り込み được render lại sau mỗi lần search nên không bind
    // trực tiếp vào radio/checkbox (site cũ phải rebind trong onSuccess).
    box.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;

      // `<select class="js-searchMaker">` trong body KHÔNG có attribute `name`,
      // nên phải nhận diện bằng identity trước khi lọc theo `name`.
      if (target === makerSelect) {
        box.querySelectorAll('input[name^="siteSearchMaker2"]').forEach(function (radio) {
          radio.checked = radio.value === target.value;
        });
        debouncedSearch();
        return;
      }

      if (!target.name) return;
      if (target.name.indexOf('siteSearchMaker2') === 0) {
        if (target.checked && makerSelect) makerSelect.value = target.value;
        // Radio đổi → search ngay, không debounce (1:1 site cũ).
        search();
        return;
      }
      if (target.name.indexOf('typeSiteSearch') === 0) {
        debouncedSearch();
      }
    });

    box.addEventListener('click', function (e) {
      if (e.target.closest('.searchBox__closeBtn, .searchBox__closeIconBtn')) {
        clearPanel();
      }
    });
  }

  function bindAll() {
    // Bind theo class của chính ô search chứ không theo `data-page-handle`: file này
    // chỉ được nhúng ở trang search-toner, và nếu template đổi thì ô vẫn chạy.
    document.querySelectorAll('.toner_SearchBox.js-searchBox').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
